export default __webpack_public_path__ + "static/media/MAC-Group_Logo.46db8244.svg";